import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import {
  blueGreyMui,
  deepPurpleMui,
  greyMui,
  MOBILE_BREAKPOINT,
  rydeColors,
} from "@ryde/theme";

export const ReportNavigationGroupContainerStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "report-navigation-group-container",
  },
)`
  margin-top: 3px;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: stretch;
  padding-inline-start: 16px;
`;

export const ReportNavigationGroupHeaderStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "report-navigation-group-header",
  },
)`
  background-color: ${greyMui._100};
  color: ${blueGreyMui._500};
  width: 100%;
  min-height: 36px;
  padding-inline-end: 12px;
  padding-inline-start: 12px;
  margin-top: 2px;
  margin-bottom: 2px;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  .collapse_toggle {
    margin-inline-start: auto;
  }
`;
export const ReportNavigationItemStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "report-navigation-item",
})`
  min-height: 36px;
  cursor: pointer;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-inline-end: 12px;
  padding-inline-start: 12px;
  font-weight: 400;
  border-radius: 6px;
  color: ${rydeColors.black};
  width: 100%;
  .report_title {
    line-height: 1.2;
  }

  .report_owner_category {
    font-size: 14px;
    margin-inline-end: 6px;
    color: ${greyMui._500};
  }
  a {
    color: inherit;
    width: 100%;
    height: 100%;
    padding-inline-end: 15px;
    padding-top: 5px;
    padding-bottom: 5px;
    display: flex;
    align-items: center;
  }
  .active {
    font-weight: 900;
  }

  .arrow_item {
    display: none;
    cursor: pointer;
    margin-inline-start: auto;
  }
  &:hover {
    transition: font-weight 150ms ease-in;
    color: ${deepPurpleMui.A400};
    background-color: rgba(179 136 255/ 0.2);
    font-weight: 600;
    .arrow_item {
      display: inline-block;
    }
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    .active {
      font-weight: 900;
    }
  }
`;

export const ReportNavigationContainerStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "report-navigation-container",
  },
)`
  margin-top: 20px;
  width: 100%;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding-bottom: 35px;
    margin-bottom: 20px;
  }
`;
